import _ from "lodash";
import {jqGetJson} from "../helpers";

export function handleDependantSelectbox(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('[data-relatedto]');
	} else {
		var $cont = $(selector + ' [data-relatedto]');
	}

	$cont.each(function (idx) {
		let $sbox = $(this);
		let defValue = $sbox.data('default-value');
		let column = $sbox.data('api-column');
		column = column !== 'undefined' ? column : 'name'

		let parentDefaultValue = $($sbox.data('relatedto')).data('default-value');
		$($sbox.data('relatedto')).data("kendoDropDownList").bind('change', function (event) {
			let parentValue = this.value() ? this.value() : parentDefaultValue

			if (parentValue != '') {
				var requestUrl = $sbox.data('url') + parentValue;

				jqGetJson(requestUrl, function (data) {
					let dataItems = new Array();

					if ($sbox.data('emptyval') == 1) {
						dataItems.push({value: '', text: '---'});
					}

					_.forEach(data, function (opt) {
						dataItems.push({value: opt.id, text: opt[column]});

						if (opt.default) {
							defValue = opt.id;
						}
					});

					var dataSource = new kendo.data.DataSource({
						data: dataItems,
					});

					let ddl = $sbox.kendoDropDownList({
						filter: "startswith",
						dataTextField: "text",
						dataValueField: "value",
						dataSource: dataSource,
						value: defValue
					}).data("kendoDropDownList");

					ddl.enable();
				})
			}

		});

		$($sbox.data('relatedto')).data("kendoDropDownList").trigger("change");
	});

}
